import React from 'react';
import { User } from 'api/models';
import { useUpdateUserQuery, useUsersMapQuery } from 'queries/members';
import { fullName } from 'utils/full-name';
import { useReportsToUsers } from '../../people-list/hooks/use-reports-to';
import { PeopleEditor } from './PeopleEditor';

interface Props {
  userId: number;
  onComplete?: any;
  selected: User | null;
}

export const EditNodeAddReportingTo = (props: Props) => {
  const { selected, onComplete, userId } = props;
  const { data: users, isLoading } = useReportsToUsers(userId);
  const { data: userMap } = useUsersMapQuery();
  const { mutate } = useUpdateUserQuery();

  const currentUser = userMap?.get(userId);

  const onCompleteWithUpdate = (selectedValues: any[]) => {
    // Selected Values is an array with only one item, since its Reporting To
    const user = userMap?.get(userId);

    if (user) {
      user.reportingTo = selectedValues.at(-1).userId;
      mutate(user);
    }
    onComplete?.();
  };

  return (
    <PeopleEditor
      title={currentUser ? `${fullName(currentUser)} reports to` : ''}
      isMulti={false}
      selected={selected ? [selected] : []}
      users={users}
      onComplete={onCompleteWithUpdate}
      isLoading={isLoading}
      stopPropogation
      style={{ height: '100%' }}
    />
  );
};
